import { BankIcon, BodyCopy, Button } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../../store/globalState";
import { useSessionStore } from "../../../../store/useSessionStore";
import { flavorClassName } from "../../../../constants";

export interface DestinationAccountInfoProps {
  onClose: () => void;
}

export const DestinationAccountInfo: React.FC<DestinationAccountInfoProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { session } = useSessionStore();
  const colorConfig = theme.whiteView;
  const {
    backgroundBtn,
    textColorBtn,
    footerColor,
    buttonShowIcon,
    buttonSize,
  } = colorConfig;

  const partnerName = session.data?.partner?.name || "Partner";

  return (
    <section className={`destination-info-slot ${flavorClassName}`}>
      <section className="destination-info-icon">
        <BankIcon
          size={72}
          className="flavor-c-icon"
          colors={[footerColor, footerColor]}
        />
      </section>
      <h2 className="foreground text-center">{t("destination.title")}</h2>
      <p className="destination-info-subtitle foreground">
        <b>{t("destination.cannotChange")}</b>
      </p>
      <BodyCopy className="muted-foreground">
        {t("destination.explanation", { partner: partnerName })}
      </BodyCopy>
      <Button
        size={buttonSize ?? "small"}
        showIcon={buttonShowIcon}
        background={backgroundBtn}
        color={textColorBtn}
        onClick={onClose}
      >
        {t("destination.gotIt")}
      </Button>
    </section>
  );
};
